import { loading, success, error } from 'State/actions';
import * as types from './types';

/**
 * Fetches the Id 1 Control Info and stores it in `CommonState`
 * on the store, under the `controlInfo` property. Can be used
 * both standalone and in a combined redux-thunk action creator
 * by doing:
 *
 * `await dispatch(getControlInfo(false))`
 * @param {Boolean} isStandAlone [Optional, defaults to `true`]
 * Indicates whether this action creator is called directly
 * (i.e. standalone) or from a combined action.
 */
export const getControlInfo = (isStandAlone = true) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CONTROL_INFO_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('ControlInfo/1');
      dispatch(success(types.CONTROL_INFO_FETCHED, response.data.Data));
    } catch (ex) {
      dispatch(error(types.CONTROL_INFO_FETCH_ERROR, ex));

      if (!isStandAlone) {
        throw ex;
      }
    }

    dispatch(loading(types.CONTROL_INFO_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/state/controlInfo/actions.js